/* GENERATED BY tools/stage_web_audio.py - DO NOT EDIT.
 *
 * Every sound effect WE made, by its own name. The names are the sound design itself:
 * `TableCard_Death` says exactly when it plays. `fx/audio.ts` maps these to game events
 * and `tools/verify_audio_coverage.py` fails on any clip neither mapped nor waived.
 *
 * Music is not here - it is staged by stage_web_assets.py from art-src/music/, so that
 * each asset has exactly one staging owner.
 */
export const CLIPS = Object.freeze({
  "Arrow_Select": "Arrow_Select.ogg",
  "Arrow_Start": "Arrow_Start.ogg",
  "Button_Click": "Button_Click.ogg",
  "Card_Card infos": "Card_Card_infos.ogg",
  "Card_Delete card": "Card_Delete_card.ogg",
  "Card_Hover": "Card_Hover.ogg",
  "Card_Release": "Card_Release.ogg",
  "Card_Spawn": "Card_Spawn.ogg",
  "Card_StartDrag": "Card_StartDrag.ogg",
  "Card_mix": "Card_mix.ogg",
  "Card_take card 2": "Card_take_card_2.ogg",
  "Effect_BuffDown": "Effect_BuffDown.ogg",
  "Effect_BuffUp": "Effect_BuffUp.ogg",
  "Effect_Curse": "Effect_Curse.ogg",
  "Effect_Freeze": "Effect_Freeze.ogg",
  "Effect_Immune": "Effect_Immune.ogg",
  "Effect_LifeSteal": "Effect_LifeSteal.ogg",
  "Effect_Poison": "Effect_Poison.ogg",
  "Effect_Rage": "Effect_Rage.ogg",
  "Effect_Resurrection": "Effect_Resurrection.ogg",
  "Effect_Summon": "Effect_Summon.ogg",
  "Effect_Taunt": "Effect_Taunt.ogg",
  "Hit_DamageAllCards_DamageOpponent_HA": "Hit_DamageAllCards_DamageOpponent_HA.ogg",
  "Hit_DamageRandomCard_HA": "Hit_DamageRandomCard_HA.ogg",
  "Lobby_OpponentEntered": "Lobby_OpponentEntered.ogg",
  "Lobby_QuickMatch": "Lobby_QuickMatch.ogg",
  "LostPopup": "LostPopup.ogg",
  "PoisoningSFX": "PoisoningSFX.ogg",
  "Spell_Arm_HA": "Spell_Arm_HA.ogg",
  "Spell_Blacksmith": "Spell_Blacksmith.ogg",
  "Spell_DestroyCard_HA": "Spell_DestroyCard_HA.ogg",
  "Spell_Disarm_HA": "Spell_Disarm_HA.ogg",
  "Spell_EvilEye_HA": "Spell_EvilEye_HA.ogg",
  "Spell_ExtraLava_ExtraHealth_HA": "Spell_ExtraLava_ExtraHealth_HA.ogg",
  "Spell_Hex": "Spell_Hex.ogg",
  "Spell_ManaBurn": "Spell_ManaBurn.ogg",
  "Spell_Refund": "Spell_Refund.ogg",
  "Spell_Release": "Spell_Release.ogg",
  "Spell_silence": "Spell_silence.ogg",
  "Spell_silenceEnemies_HA": "Spell_silenceEnemies_HA.ogg",
  "Spell_spellDamage_HA": "Spell_spellDamage_HA.ogg",
  "Spell_switch": "Spell_switch.ogg",
  "Spell_undefeatable_HA": "Spell_undefeatable_HA.ogg",
  "TableCard_Attack": "TableCard_Attack.ogg",
  "TableCard_Buff": "TableCard_Buff.ogg",
  "TableCard_Damage": "TableCard_Damage.ogg",
  "TableCard_Death": "TableCard_Death.ogg",
  "TableCard_Heal": "TableCard_Heal.ogg",
  "TableCard_Spawn": "TableCard_Spawn.ogg",
  "Timer_RunningOut": "Timer_RunningOut.ogg",
  "VictoryPopup": "VictoryPopup.ogg",
  "YourTurn": "YourTurn.ogg",
} as const);

export type ClipName = keyof typeof CLIPS;
